import React from "react"
import { shallowEqual } from "react-redux"

import TableBikeFleet from "./Partials/TableBikeFleet/TableBikeFleet"
import { useAppDispatch, useAppSelector } from "store/hooks"
import { getBikeFleetThunk } from "./slice/BikeFleetThunk"
import { useCurrentSearchParams } from "hooks/useCurrentSearchParams"
import { useDidMountEffect } from "hooks/useDidMountEffect"
import { getFilteredBikeFleet } from "./slice/bikeFleetSlice"
import { CheckOutStateEnum } from "store/type"
import { defaultBikeFleetQuery } from "./constant"
import { useHasBikeFleet } from "./hooks/useHasBikeFleet"
import { FormBikeFleetChoice } from "./Partials/FormBikeFleetChoice"
import { useAlert, useTheme } from "hooks"
import { LayoutBikeFleet } from "./Partials/LayoutBikeFleet"

export const BikeFleet = () => {
	const dispatch = useAppDispatch()
	const datas = useAppSelector((state) => state.bikeFleet.filteredBikeFleet, shallowEqual)
	const checkOutState = useAppSelector((state) => state.bikeFleet.checkOutState.bikeFleet)
	const [{ status }] = useCurrentSearchParams(defaultBikeFleetQuery)
	const refTable = React.useRef<any>(null)
	const hasAnAccount = useHasBikeFleet()
	const error = useAppSelector((state) => state.bikeFleet.error.bikeFleet)
	const { alert } = useAlert()

	const {
		currentTheme: { id_api },
	} = useTheme()

	React.useEffect(() => {
		if (hasAnAccount) {
			//la clef status sera utilisé dans le builder, a ne pas supprimer
			dispatch(getBikeFleetThunk({ status: status, operator: id_api }))
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [hasAnAccount, id_api])

	React.useEffect(() => {
		if (error) alert("error", error as string)
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [error])

	useDidMountEffect(() => {
		if (checkOutState === CheckOutStateEnum.READY && hasAnAccount)
			dispatch(getFilteredBikeFleet({ status }))
		refTable.current?.resetPage()
	}, [status])

	return (
		<LayoutBikeFleet>
			{hasAnAccount ? (
				<TableBikeFleet ref={refTable} datas={datas} />
			) : (
				<FormBikeFleetChoice />
			)}
		</LayoutBikeFleet>
	)
}
